import ApiFactory from "./ApiFactory";

const BaseAPI = ApiFactory("Default", {});

export const getAll = BaseAPI.getAll;
export const getList = BaseAPI.getList;
export const add = BaseAPI.add;
export const addAsync = BaseAPI.addAsync;
export const update = BaseAPI.update;
export const updateAsync = BaseAPI.updateAsync;
export const deleteAll = BaseAPI.deleteAll;
export const deleteAllAsync = BaseAPI.deleteAllAsync;
export const getOneById = BaseAPI.getOneById;
export const getListAsync = BaseAPI.getListAsync;
export const getAsync = BaseAPI.getAsync;
export const getAsyncWithThrow = BaseAPI.getAsyncWithThrow;
export const patch = BaseAPI.patch;
export const patchAsync = BaseAPI.patchAsync;

export default BaseAPI;
